import { useMemoizedFn } from 'ahooks';
import React, { useEffect, useState } from 'react';
import { Dialog, Form, Select, Textarea } from 'tdesign-react';
import { isVoid, toTsOptions } from '@/utils/common';
import { getLibsFromStore, saveLib } from '@/services/execComponentService';
import Tip from '@/components/Tip';

const { FormItem } = Form;

export default function LibsModal({
  visible,
  handleClose,
  componentStencilId,
  productLibId,
  envId,
  clusterId,
}) {
  const [options, setOptions] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [form] = Form.useForm();

  const loadData = useMemoizedFn(async (params) => {
    const { data } = await getLibsFromStore({
      ...params,
      componentStencilId,
      envId,
      clusterId,
      productLibId,
    });
    setOptions(
      data
        .split(',')
        .filter((item) => !isVoid(item))
        .map((item) => ({
          label: item,
          value: item,
        })),
    );
  });

  useEffect(() => {
    if (visible) {
      loadData();
      form.reset();
    }
  }, [visible, loadData, form]);

  const handleSubmit = async ({ validateResult, fields }) => {
    if (validateResult === true) {
      try {
        setSubmitting(true);
        await saveLib({
          componentStencilId,
          envId,
          clusterId,
          productLibId,
          fileNames: [fields],
        });
        handleClose(true);
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    }
  };

  return (
    <Dialog
      header='从版本库拉取版本信息并导入'
      visible={visible}
      onClose={() => handleClose()}
      onConfirm={() => form.submit()}
      confirmBtn={{
        loading: submitting,
        content: '确认',
      }}
    >
      <Form form={form} style={{ width: '90%' }} onSubmit={handleSubmit}>
        <FormItem name='fileName' label='选择物料' rules={[{ required: true }]}>
          <Select options={toTsOptions(options)} clearable filterable />
        </FormItem>
        <FormItem
          name='fileDesc'
          label={<Tip content='填写该物料包备注信息，包含变更内容、变更依赖等信息'>备注</Tip>}
        >
          <Textarea placeholder='备注' />
        </FormItem>
      </Form>
    </Dialog>
  );
}
